import React, { useState } from 'react';
import ConfirmDestructiveDialog from '@/components/ConfirmDestructiveDialog';
import { InlineToggle } from '@/components/ui';

type Props = {
  selectedCount: number;
  alsoClearActivity: boolean;
  onAlsoClearActivityChange: (value: boolean) => void;
  onClose: () => void;
  onConfirm: () => Promise<void>;
};

export default function BulkDeleteJobsConfirmModal({
  selectedCount,
  alsoClearActivity,
  onAlsoClearActivityChange,
  onClose,
  onConfirm,
}: Props) {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  async function confirm() {
    setSubmitting(true);
    setError('');
    try {
      await onConfirm();
      onClose();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Delete failed');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <ConfirmDestructiveDialog
      title="Delete selected jobs?"
      onClose={onClose}
      closeOnBackdrop={!submitting}
      footer={
        <>
          <button type="button" className="btn btn-ghost" disabled={submitting} onClick={onClose}>
            Cancel
          </button>
          <button type="button" className="btn btn-danger" disabled={submitting} onClick={() => void confirm()}>
            {submitting ? 'Deleting…' : 'Delete jobs'}
          </button>
        </>
      }
    >
      {error && <div className="alert alert-error">{error}</div>}

      <p className="modal-lead">
        Permanently remove <strong>{selectedCount}</strong> selected job record(s) and their items?
      </p>

      <InlineToggle
        checked={alsoClearActivity}
        onChange={onAlsoClearActivityChange}
        disabled={submitting}
        label="Also clear activity logs"
      />

      <p className="modal-hint muted">
        Removes deliveries, pipeline executions, and fetch runs linked to the selected jobs. Discovered links are
        kept.
      </p>
    </ConfirmDestructiveDialog>
  );
}
